export default __webpack_public_path__ + "static/media/datav2banner.27843242.jpg";